import { useQuery } from "@apollo/client";
import GameInfo from "../lib/models/GameInfo";
import mapGameData from "../lib/utils/mapGameData";
import { GameQuery } from "../gql/queries";
import { GameSubscription } from "../gql/subscriptions";
import { useEffect, useState } from "react";

export const useGameQuery = (gameId: string)
  : [GameInfo | undefined, boolean] => {
  const [loading, setLoading] = useState(true)

  const { data, subscribeToMore, loading: queryLoading } = useQuery(GameQuery, { variables: { id: gameId } })
  let gameData: GameInfo | undefined = undefined
  if (data && data.getGame) {
    gameData = mapGameData(data.getGame)
  }
  useEffect(() => {
    subscribeToMore({
      document: GameSubscription,
      variables: { id: gameId },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data && !subscriptionData.data.onUpdateGame) return prev
        return {
          getGame: subscriptionData.data.onUpdateGame,
          ...prev
        }
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (loading && !queryLoading && data) {
      setLoading(false)
    }
  }, [data, loading, queryLoading])

  return [gameData, loading]
}